<template>
    <div>
        <div class="inline-block" @click="showModal">
            <slot />
        </div>

        <adaptive-form-modal
            :name="modalName"
            :primary-button-text="modalButtonText"
            :primary-button-class="modalButtonClass"
            :title="modalButtonText"
            :method="requestMethod"
            :action="actionUrl"
            :redirect-to="redirectUrl"
        >
            {{ confirmText }}
        </adaptive-form-modal>
    </div>
</template>

<script>
    import random from 'lodash-es/random';

    export default {
        props: {
            requestMethod: {
                required: true,
                type: String,
            },
            actionUrl: {
                required: true,
                type: String,
            },
            redirectUrl: {
                required: false,
                type: String,
                default: null,
            },
            modalButtonText: {
                required: true,
                type: String,
            },
            modalButtonClass: {
                required: false,
                type: String,
                default: 'is-danger',
            },
            confirmText: {
                required: false,
                type: String,
                default: 'Är du säker?',
            },
        },

        data() {
            return {
                modalName: 'confirm-modal-' +  random(1, 99999),
            };
        },

        methods: {
            showModal() {
                this.$modal.show(this.modalName);
            },
        },

    };
</script>
